module.exports = __webpack_public_path__ + "img/ef80714.jpg";